import React, { Component } from "react";
//import _ from "lodash";
//import {history} from "../../store/store";
import BaseLayout from "./../../templates/base";
import Loading from "../../elements/loading";
import ProjectRevisionForm from "../../elements/revision/project";
import RevisionShow from './../../elements/revision/widget/revision_show';


class RevisionProject extends Component {
	render() {
		let { revision, project } = this.props;		
		return (
			(revision.isFetching || project.isFetching) ? <Loading /> : <ProjectRevisionForm {...this.props} />
		)
	}


	//Nueva Propuesta de Carga inicial AEH 30/04/2018
	componentWillMount() {
		let {state, municipality, modality} = this.props.match.params;

		this.props.fetchRevisionProject(modality, state, municipality);
	}

	componentWillReceiveProps(nextprops) {
		let {modality, state, municipality} = nextprops.match.params;
		if(nextprops.match.params !== this.props.match.params) {
			this.props.fetchRevisionProject(modality, state, municipality);
		}
	}
}

export default BaseLayout(RevisionProject, {
	title: 'Revisión de proyecto',
	subnav:{
		icon: 'fa-check-square-o',
		name: 'Revisión',
		actions:[
			{
				type: 'element',
				url: null,
				name: 'Visualizar',
				element: <RevisionShow />
			}
		]
	},
	stateNav: true
});


// WEBPACK FOOTER //
// ./src/layouts/revision/project.jsx